import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Overview() {
  const { t } = useI18n();
  const paragraphs = [t.overview.p1, t.overview.p2, t.overview.p3];

  return (
    <section
      id="overview"
      className="relative z-10 scroll-mt-24 bg-[#050505] px-6 pt-36 pb-24 sm:pl-[120px] sm:pr-16"
      data-testid="overview-section"
    >
      <motion.span
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="font-mono-accent text-[11px] uppercase tracking-[0.3em] text-[#a855f7]"
      >
        [ 01 — {t.sections.overview} ]
      </motion.span>

      <div className="mt-8 grid grid-cols-1 gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-24">
        <motion.h2
          custom={0}
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="font-head text-4xl font-light leading-[1.05] tracking-tight text-white sm:text-6xl"
        >
          {t.overview.headA}
          <br />
          <span className="text-white/40">{t.overview.headB}</span>
        </motion.h2>

        <div className="flex flex-col gap-7 lg:pt-3">
          {paragraphs.map((p, i) => (
            <motion.p
              key={i}
              custom={i + 1}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="max-w-xl font-body text-base leading-relaxed text-white/60"
            >
              {p}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
}
